export default "__VITE_ASSET__4f0b4456__"